module.exports = __webpack_public_path__ + "static/media/empty-selection.b90707af.png";


//////////////////
// WEBPACK FOOTER
// ./src/containers/PropertySearch/images/empty-selection.png
// module id = 1842
// module chunks = 0